<!--
 * @Author: liushuaibo liushuaibo@yangxuan.net
 * @Date: 2022-08-10 17:39:14
 * @LastEditors: liushuaibo liushuaibo@yangxuan.net
 * @LastEditTime: 2022-08-11 18:20:15
 * @FilePath: \partner.chaoyongtuan.com\src\views\shopManage\trusteeship\list\components\claim.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<el-dialog title="确认认领" width="400px" show-close :visible.sync="claimDialog">
		<template slot="title">
			<p>
				<span>确认认领</span>
				<span class="fz-14 yx-color-text-regular ml-6">{{ '(共' + total + '个商品)' }}</span>
			</p>
		</template>
		<p>确认认领商品</p>
		<div slot="footer" class="dialog-footer">
			<el-button @click="claimDialog = false">取 消</el-button>
			<el-button type="primary" @click="claimConfirm">确 定</el-button>
		</div>
	</el-dialog>
</template>
<script>
import { trusteeshipClaims } from '@/api/shopManage';
export default {
	data() {
		return {
			claimDialog: false,
			params: {
				productIds: [],
				opType: '1',
			},
			total: 1,
		};
	},
	methods: {
		initClaim(row) {
			this.params = {
				productIds: [],
				opType: '1',
			};
			if (Array.isArray(row)) {
				if (!row.length) {
					this.$message.warning('请选择商品');
					return;
				}
				this.params.productIds = row.map(item => item.product_id);
				this.total = row.length;
			} else {
				this.total = 1;
				this.params.productIds = [`${row.product_id}`];
			}
			this.claimDialog = true;
		},
		async claimConfirm() {
			const { code } = await trusteeshipClaims(this.params);
			if (code == 0) {
				this.$message.success('认领成功');
				this.$emit('refreshList');
				this.claimDialog = false;
			}
		},
	},
};
</script>
